// extracted by mini-css-extract-plugin
export var fadePop = "PeopleList-module--fade-pop--41b21";
export var growHeightIn = "PeopleList-module--grow-height-in--f5971";
export var heading = "PeopleList-module--heading--efc43";
export var main = "PeopleList-module--main--4d916";
export var person = "PeopleList-module--person--e12b7";
export var side = "PeopleList-module--side--f1948";